import '@seencast/player-core/styles.css';
import './styles.css';
import { PlayerApp } from './app.ts';

// Player entry point (docs/04). Boots the PAIRING ⇄ RUNNING state machine and
// registers the service worker so the app shell loads offline. Zero runtime
// dependencies — the whole player is hand-written TS for weak signage hardware.

function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator)) {
    console.warn('[player] Service Worker unsupported; offline shell disabled.');
    return;
  }
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (reg) => console.info('[player] SW registered', reg.scope),
      (err) => console.error('[player] SW registration failed', err),
    );
  });
}

const appEl = document.getElementById('app');
if (appEl) {
  new PlayerApp(appEl).boot().catch((e) => console.error('[player] fatal', e));
} else {
  console.error('[player] #app root missing');
}

registerServiceWorker();
